import { Component, OnInit, ViewChild  } from '@angular/core';
import { HttpClient } from '@angular/common/Http';
import { KjonnValg, Service } from './home.services';
import notify from 'devextreme/ui/notify';
import { FormGroup, FormControl } from '@angular/forms';
import { Headers, RequestOptions } from '@angular/http';
import { NullAstVisitor, Identifiers } from '@angular/compiler';
import { DxFormModule, DxFormComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { isNull } from 'util';
//import { ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [Service]
})


export class HomeComponent implements OnInit {
  @ViewChild(DxFormComponent) myform: DxFormComponent;
  omsetning: any;
  firma: any;
  ManglerOmsetning: any;
  mittfirma: any;
  valgtTab: string;
  HarInnrapportert: boolean;
  ngInnloggetFirma: string;

    
  constructor(private http: HttpClient, private service:Service,private router: Router) {
    this.valgtTab = "OMS"
  }

  ngOnInit(): void {
    // Make the HTTP request:
    var slt_id = localStorage["slt_id"];
    this.HentOmsetning(slt_id);
    //this.HentFirma(slt_id);
    
    var ID_NAVN = localStorage["id_navn"];
    //document.getElementById("InnloggetFirma").value = ID_NAVN;
    //ngFirma.value = ID_NAVN;
    this.ngInnloggetFirma = "Firma innlogget: " + ID_NAVN; 

    this.HarInnrapportert = true;
    var innrappdato = localStorage["innrappdato"];
    if (innrappdato=='null')
    //if (!innrappdato.HasValue)
    {
      this.HarInnrapportert = false;
    }

  }
 



  LoggUtClick() {
    localStorage.removeItem("token");
    localStorage.removeItem("slt_id");
    //localStorage.clear();
    this.router.navigateByUrl('/login');
    //window.location.reload(true);
  }


  HentOmsetning(slt_id:string){
    {
      //this.http.get('http://localhost:64475/api/omsattmengde/'+slt_id).subscribe(data => {
      //https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/firma/5509
        this.http.get('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/omsattmengde/'+slt_id).subscribe(data => {
      this.omsetning = data;});
    }
  }
  HentFirma(slt_id:string){
    {
      this.http.get('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/firma/'+slt_id).subscribe(data => {
      this.firma = data;
    }
      );
    }
  }
  


  updateOmsattMengde(event) {
    this.http.put('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/omsattmengde/'+ event.key.id ,event.key).subscribe(data => {
      // Read the result field from the JSON response.
      this.omsetning = data;
    });
  }

  Innrapporter(event) {
    //notify('Innrapporterer');
    var slt_id = localStorage["slt_id"];
    //notify(slt_id);
    //this.http.put('http://localhost:64475/api/firma/'+event.key.id ,event.key).subscribe(data => {
    //this.http.put('http://localhost:64475/api/firma/'+slt_id,event.key).subscribe(data => {
      this.http.get('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/OmsetningMangler/'+slt_id,event).subscribe(data => {
      this.ManglerOmsetning = data;
      if (this.ManglerOmsetning && this.ManglerOmsetning.length > 0) {
          notify ('Omsetningstall mangler for noen preparater/pkn størrelser. Dette må fylles ut før man kan innrapportere!!!');
      } else {
          this.http.put('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/firma/'+slt_id,event).subscribe(data => {
          this.firma = data;
        });
        //notify ('Vi har nå mottatt din innrapportering av miljøavgift');
        //alert(dialogResult ? "Vi har nå mottatt din innrapportering av miljøavgift" : "Innrapportering OK");
        alert('Vi har nå mottatt din innrapportering av miljøavgift');

      }
    });
  }

  InnrapporterOK(event) {
    notify ('Tallene er allerede innrapportert');
  }

  onValueChanged(event) {
    console.log(event.previousValue);
    console.log(event.value);
    var slt_id = localStorage["slt_id"];
    this.HentOmsetning(slt_id);
  }  
}




// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/home/home.component.ts